import * as React from "react";
const SVGComponent = ({color='black', height=24, width=24, ...props}:any) => (
    <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 3.0625H9C9.33355 3.0625 9.65535 3.17816 9.91113 3.3877L10.0166 3.4834C10.2862 3.75298 10.4375 4.11875 10.4375 4.5V6.0625H12C12.5077 6.0625 12.9974 6.23863 13.3867 6.55762L13.5469 6.70312C13.9571 7.11336 14.1875 7.66984 14.1875 8.25V11.3125H17.3125V10.5C17.3125 10.1188 17.4638 9.75298 17.7334 9.4834C18.003 9.21382 18.3688 9.0625 18.75 9.0625H21.75C22.1312 9.0625 22.497 9.21381 22.7666 9.4834C23.0362 9.75298 23.1875 10.1188 23.1875 10.5V13.5C23.1875 13.8812 23.0362 14.247 22.7666 14.5166C22.497 14.7862 22.1312 14.9375 21.75 14.9375H18.75C18.3688 14.9375 18.003 14.7862 17.7334 14.5166C17.4638 14.247 17.3125 13.8812 17.3125 13.5V12.6875H14.1875V15.75C14.1875 16.3302 13.9571 16.8866 13.5469 17.2969C13.1366 17.7071 12.5802 17.9375 12 17.9375H10.5625V16.5625H12C12.2155 16.5625 12.4218 16.4766 12.5742 16.3242C12.7266 16.1718 12.8125 15.9655 12.8125 15.75V8.25C12.8125 8.03451 12.7266 7.82815 12.5742 7.67578C12.4218 7.52341 12.2155 7.4375 12 7.4375H10.4375V9C10.4375 9.38125 10.2862 9.74702 10.0166 10.0166C9.74702 10.2862 9.38125 10.4375 9 10.4375H4.5C4.11875 10.4375 3.75298 10.2862 3.4834 10.0166C3.21381 9.74702 3.0625 9.38125 3.0625 9V4.5C3.0625 4.16645 3.17816 3.84465 3.3877 3.58887L3.4834 3.4834C3.75298 3.21381 4.11875 3.0625 4.5 3.0625Z"
      fill={color}
      stroke={color}
      strokeWidth={0.125}
    />
    <rect
      x={2.5}
      y={13.5}
      width={8}
      height={8}
      rx={1}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 2"
    />
  </svg>
);
export default SVGComponent;
